// eslint-disable-next-line no-restricted-imports
import { InterfaceProducts, SkinProducts, MechProducts, GridProducts, ProductRules, ConstantProducts } from './generated/products'

import { getDenormalizedSkinGridProducts } from './data/getDenormalizedSkinGridProducts'
import WallColors from './data/WallColors'
import { sortByColor, sortByItemNo } from './products/productSorting'
import {
  GridProduct,
  InterfaceProduct,
  MechProduct,
  ProductRule,
  SkinProductOption,
  SkinProduct,
  ConstantProductsShape,
} from './types/productTypes'
import { ProductDataShape } from './ProductDataShape'

export function createLocalProductDataContext(data: {
  InterfaceProducts: readonly InterfaceProduct[]
  SkinProducts: readonly SkinProduct[]
  MechProducts: readonly MechProduct[]
  GridProducts: readonly GridProduct[]
  ProductRules: readonly ProductRule[]
  ConstantProducts: ConstantProductsShape
}): ProductDataShape {
  const {
    InterfaceProducts,
    SkinProducts,
    MechProducts,
    GridProducts,
    ProductRules,
    ConstantProducts,
  } = data

  const SkinGridProducts: readonly SkinProductOption[] = getDenormalizedSkinGridProducts(SkinProducts, GridProducts)

  return {
    interfaces: InterfaceProducts.slice().sort(sortByColor),
    skins: SkinProducts.slice(),
    mechs: MechProducts.slice(),
    grids: GridProducts.slice().sort().sort(sortByItemNo),
    skinGridProducts: SkinGridProducts.slice(),
    rules: ProductRules,
    constants: ConstantProducts,
    wallColorOptions: WallColors,
    mechMap: MechProducts.reduce<Record<string, MechProduct>>((accum, curr) => {
      accum[curr.itemNo] = curr
      return accum
    }, { }),
    interfaceMap: InterfaceProducts.reduce<Record<string, InterfaceProduct>>((accum, curr) => {
      accum[curr.itemNo] = curr
      return accum
    }, { }),
  }
}

/**
 * Static product data object that uses the product data baked into the app
 * Should not be used in production, but can be used in tests and development
 */
export const LocalProductDataContextImplementation = createLocalProductDataContext({
  InterfaceProducts,
  SkinProducts,
  MechProducts,
  GridProducts,
  ProductRules,
  ConstantProducts,
})
